import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-table-loading-indicator',
  templateUrl: './table-loading-indicator.component.html',
  styleUrls: ['./table-loading-indicator.component.scss']
})
export class TableLoadingIndicatorComponent {
  @Input() public data: any[] | null = null;
  @Input() public loading: boolean = false;
}
